var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentLinksNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 7.34118,
    fill: "#857BF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2527 44.892C30.7334 44.892 34.0717 43.4827 36.5329 40.9741C38.9942 38.4655 40.377 35.0631 40.377 31.5154C40.377 27.9676 38.9942 24.5652 36.5329 22.0566C34.0717 19.548 30.7334 18.1387 27.2527 18.1387L27.2527 31.5154L27.2527 44.892Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7473 7.09429C21.2666 7.09429 17.9283 8.50362 15.4671 11.0122C13.0058 13.5208 11.623 16.9233 11.623 20.471C11.623 24.0187 13.0058 27.4211 15.4671 29.9297C17.9283 32.4383 21.2666 33.8477 24.7473 33.8477L24.7473 20.471L24.7473 7.09429Z",
    fill: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLinksNew);
export default __webpack_public_path__ + "static/media/PaymentLinks_new.b43a072df8ed3794db3fabb9a8548507.svg";
export { ForwardRef as ReactComponent };